<script>
import List from '../../baseComponents/list'

export default {
	extends: List,
	data() {
		return {
			defaultSort: '-date',
			items: [
				{ header: 'Date', value: (item) => this.$options.filters.formatDate(item.createdAt), sort: 'createdAt', filter: { name: 'createdAt', type: 'date' } },
				{ header: 'Action', value: (item) => item.action, sort: 'action', filter: { name: 'action'} },
				{ header: 'Utilisateur', value: (item) => !item.user ? 'Automatique' : item.user.lastName + ' ' + item.user.firstName, sort: 'user.lastName,user.firstName', filter: { name: 'user.lastName,user.firstName', type: 'multiple' } },
				{ header: 'Reference', value: (item) => item.collectionRef, sort: 'collectionRef', filter: { name: 'collectionRef'}},
				{ header: 'Id', value: (item) => item.documentId, sort: 'documentId', filter: { name: 'documentId'}},
				{ header: 'Contenu', value: (item) => item.body, sort: false, filter: false }
			]
		}
	}
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/logs/log.list.vue